// ============ plugin import ============ //
import React,{useState, useEffect, useImperativeHandle, forwardRef} from 'react'
import Select from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
// ============ component import ============ //
import { specialCharacterValidate } from '../../../../../../../../../component/common/Helper';
import AlertMessage from '../../../../../../../../../component/common/AlertMessage';
import ValidationMessage from '../../../../../../../../../component/common/ValidationMessage';
import ButtonLoader from '../../../../../../../../../component/common/ButtonLoader';
import { 
    typeOfResponse, 
    followUpDetailsOptions,
    productFeatureResponseType
} from '../../../../../../../../../constants/selectOptions';

const ProductFeatureAssociationSetupForm = forwardRef((props, ref) => {

    const {
        formValidateError,
        formData,
        updateAssociationData,
        formActionType,
        isButtonLoader
    } = props;
    // =========================== Others form data manage ====================== //
    const [ selectAssociation, setSelectAssociation ] = useState([]);
    const pfAssociation = formData['step3'].product_features_association;
    const productFeatureAssData = formData['step3'].product_features_association_data;
    useEffect(() => {
        if(Object.keys(pfAssociation).length > 0){
            const selectAss = Object.entries(pfAssociation).flatMap(
                ([productName, data]) => {
                    return data.feature_list.map((feature) => {
                        const label = `Product: ${productName}, Feature: ${feature.value}`;
                        return {
                            label,
                            value: label
                        };
                    });
                }
            );
            setSelectAssociation(selectAss)
        }
        if(productFeatureAssData.length > 0){
            var associatedValues = new Set(
                productFeatureAssData.flatMap(item => item.select_association.map(sa => sa.value))
            );
            setSelectAssociation(prevData =>
                prevData.filter(item => !associatedValues.has(item.value))
            );
        }
    },[pfAssociation, productFeatureAssData]);
    const [ responseType , setResponseType ] = useState('');
    const [ followUpDetailsType , setFollowUpDetailsType ] = useState('');
    const [ pfAssAffiramOrDeny, setPfAssAffiramOrDeny] = useState('');

    const [ othersFormError, setOthersFormError ] = useState({});
    const [ othersFormData, setOthersFormData ] = useState({
        select_association: null,
        add_example: "",
        select_response_type : null,
        final_response : "",
        initial_response : "",
        fail_response : "",
        api_end_point : "",
        action_name : "",
        folow_up_details : null,
        affiram_or_deny : null,
        select_action : null,
        closing_utterance : "",
        feedback : ""
    });

    const validateField = (name, value) => {
        let error = "";
        if (name === "select_association") {
            if (!value || value === null) {
                error = "Please select association";
            }
        }

        if (name === "add_example") {
            if (!value) {
                error = "Example is required.";
            }
        }
        if (name === "select_response_type") {
            if (!value || value === null) {
                error = "Response type is required.";
            }
        }
        if(responseType === 'static_response'){
            if(name === 'final_response'){
                if (!value) {
                    error = "Static response is required.";
                }
            }
        }

        if (name === "action_name") {
            if (!value) {
                error = "Action is required.";
            }
        }
        return error;
    }

    const othersInputOnchange = (selectedOption, actionMeta) => {

        if (actionMeta?.name) {
            // ------- manage select field --------- //
            const { name } = actionMeta;
            if(name === 'select_response_type'){
                if(selectedOption){
                    setResponseType(selectedOption.value)
                }
                else{
                    setResponseType('')
                }
            }
            if(name === 'folow_up_details'){
                if(selectedOption){
                    setFollowUpDetailsType(selectedOption.value);
                }
                else{
                    setFollowUpDetailsType('')
                }
            }
            if( name === 'affiram_or_deny'){
                if(selectedOption){
                    setPfAssAffiramOrDeny(selectedOption.value)
                }
                else{
                    setPfAssAffiramOrDeny('')
                }
            }

            const fieldError = validateField(name, selectedOption);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: selectedOption,
            }));
        }
        else if(selectedOption?.target){
            // ----- manage input field -------- //
            const { name, value } = selectedOption.target;
            let newVal = value
            const fieldsToValidate = ['action_name'];
            if (fieldsToValidate.includes(name)) {
                newVal = specialCharacterValidate(newVal);
            }
            const fieldError = validateField(name, value);
            setOthersFormError((prevErrors) => ({
                ...prevErrors,
                [name]: fieldError,
            }));
            setOthersFormData((prevData) => ({
                ...prevData,
                [name]: newVal,
            }));
        }
    }
    const othersDataSaveHandler = (e) => {
        e.preventDefault();
        const newErrors = {};
        for (const key in othersFormData) {
            newErrors[key] = validateField(key, othersFormData[key]);
        }
        setOthersFormError(newErrors);
        if (Object.keys(newErrors).every((key) => !newErrors[key])) {
            props.associatedDate(othersFormData)
        }
    }
    useImperativeHandle(ref, () => ({
        resetForm: () => {
            setOthersFormData({
                select_association:null,
                add_example: "",
                select_response_type : null,
                final_response : "",
                initial_response : "",
                fail_response : "",
                api_end_point : "",
                action_name : "",
                folow_up_details : null,
                affiram_or_deny : null,
                select_action : null,
                closing_utterance : "",
                feedback : ""
            });
            setResponseType('')
            setFollowUpDetailsType('')
        }
    }));

    useEffect(() =>{
        if( updateAssociationData.length > 0 ){
            if(formActionType === 'update'){
                let associationData = updateAssociationData[0];
                setOthersFormData((prevState) => ({
                    ...prevState,
                    select_association: associationData.select_association,
                    add_example: associationData.add_example,
                    select_response_type: associationData.select_response_type,
                    final_response: associationData.final_response,
                    initial_response: associationData.initial_response,
                    fail_response: associationData.fail_response,
                    api_end_point: associationData.api_end_point,
                    action_name: associationData.action_name,
                    folow_up_details: associationData.folow_up_details,
                    affiram_or_deny: associationData.affiram_or_deny,
                    select_action: associationData.select_action,
                    closing_utterance: associationData.closing_utterance,
                    feedback: associationData.feedback,
                }));
                if(associationData.select_response_type){
                    othersInputOnchange(
                        associationData.select_response_type, 
                        {action : "select-option",name : "select_response_type"}
                    )
                }
                if(associationData.folow_up_details){
                    othersInputOnchange(
                        associationData.folow_up_details, 
                        {action : "select-option",name : "folow_up_details"}
                    )
                }
                if(associationData.affiram_or_deny){
                    othersInputOnchange(
                        associationData.affiram_or_deny, 
                        {action : "select-option",name : "affiram_or_deny"}
                    )
                }
            }
            else{
                setOthersFormData({
                    select_association: null,
                    add_example: "",
                    select_response_type : null,
                    final_response : "",
                    initial_response : "",
                    fail_response : "",
                    api_end_point : "",
                    action_name : "",
                    folow_up_details : null,
                    affiram_or_deny : null,
                    select_action : null,
                    closing_utterance : "",
                    feedback : ""
                });
            }
        }
    },[updateAssociationData]);
    // ------- manage service data ------- //
    const [ actionName, setActionName ] = useState([]);

    const othersFormSetupAction = formData.step2.others_form_setup;
    const pfAssAction = formData.step3.product_features_association_data;
    const serviceAction = formData.step4.service_setup;
    const serviceCombinedData = [
        ...othersFormSetupAction, 
        ...pfAssAction, 
        ...serviceAction
    ];
    useEffect(() => {
        if(serviceCombinedData.length > 0){
            const uniqueActions = [...new Map(serviceCombinedData.map(item => [item.action_name, item])).values()];
            var selectAction = uniqueActions.map(item => ({
                label: item.action_name,
                value: item.action_name
            }));
            setActionName(selectAction)
        }
    }, [othersFormSetupAction, pfAssAction, serviceAction])

    const infoPopupData = {
        'select_association' : {
            'title' : 'Select association',
            'info' : 'Now, you select each Association and provide the instructions to the Agent about how it should respond.',
        },
        'add_example' : {
            'title' : 'Add example',
            'info' : 'Provide an example of how your customer would query about this information item. For example, "What is the price of your EV?" or "What is the tarriff on your rooms?" etc.',
        },
        'select_response_type' : {
            'title' : 'Select type of response',
            'info' : 'Static Response is a pre-determined answer that you provide. The Agent will provide the same response everytime. Use DB Response when you want the Agent to Fetch responses from a DB. Note that you need to integrate the Query with an API end-point we provide for this. Use API response for fetching reponse from another system like a CRM, or using an LLM. Here to you need to integrate the API using the endpoints we provide.',
        },
        'action_name' : {
            'title' : 'Action name',
            'info' : 'Give a unique name for this specific Action. All the information will be saved and used under this Action Name.',
        },
        'folow_up_details' : {
            'title' : 'Follow up details',
            'info' : `Follow-up Actions automatically trigger an Agent response after fulfilling the customer query. For example, after providing product information, you may want the Agent to ask, "Would you like to place an order now?"
            Opt-in Action is when you would like the Agent to query like, "Would you like to place an order?". If the customer says Yes, you can add Sell Action as the Follow-up Action. Note that Sell Action should be pre-created to be invoked here. If you have not already created, you can come back here using Edit Agent mode and add it later.  If the customer denies with a No, you can provide some response such as, "That is fine. Let me know if I can do anything else for you."
            Use Closing Utterance for a simple closing response such as, "Glad to be of help."
            Feedback is a specific type of Follow-up Action where you can collect Ratings or some feedback. This feature is not available yet.
            Use this for providing information in an interactive mode to your customers. It can be a Product or a Service that you provide. For example, your customer may inquire about the EV you sell or a Hotel Accommodation.`,
        },
    }
    const infoOpenOnCLick = (param) => {
        props.isInfoOpenHandler({
            type: 'open',
            data: infoPopupData[param]
        })
    }


    return (
        <>
            <div className='row'>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select Association
                    </label>
                     <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('select_association')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select' 
                        options={selectAssociation}
                        placeholder='Select an option'
                        name="select_association"
                        onChange={othersInputOnchange}
                        value={othersFormData.select_association}
                    />
                    {
                        othersFormError.select_association &&
                        <ValidationMessage className='text-danger' message ={othersFormError.select_association}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Add Example User Response
                    </label>
                    <span 
                    className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                    onClick={(e) => infoOpenOnCLick('add_example')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter example"
                        name="add_example"
                        onChange={othersInputOnchange}
                        value={othersFormData.add_example}
                    />
                    {
                        othersFormError.add_example &&
                        <ValidationMessage className='text-danger' message ={othersFormError.add_example}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Select type of Response
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('select_response_type')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid' 
                        classNamePrefix='react-select'
                        options={productFeatureResponseType}
                        placeholder='Select an option'
                        name="select_response_type"
                        onChange={othersInputOnchange}
                        value={othersFormData.select_response_type}
                    />
                    {
                        othersFormError.select_response_type &&
                        <ValidationMessage className='text-danger' message ={othersFormError.select_response_type}/>
                    }
                </div>

                {(responseType === 'static_response' || responseType === 'dynamic_response') && (
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            Add Initial Response
                        </label>
                        <textarea 
                            className="form-control form-control-solid" 
                            rows="4"
                            placeholder='Enter initial response' 
                            name='initial_response'
                            onChange={othersInputOnchange}
                            value={othersFormData.initial_response}
                        ></textarea>
                    </div>
                )}

                {(responseType === 'static_response') && (
                    <div className='col-md-12 mb-5'>
                        <label className="form-label required">
                            Add Final Response
                        </label>
                        <textarea 
                            className="form-control form-control-solid" 
                            rows="4"
                            placeholder='Enter final response'
                            name='final_response'
                            onChange={othersInputOnchange}
                            value={othersFormData.final_response}></textarea>
                        {
                            othersFormError.final_response &&
                            <ValidationMessage className='text-danger' message ={othersFormError.final_response}/>
                        }
                    </div>
                )}
                {(responseType === 'dynamic_response') && (
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            API end point
                        </label>
                        <textarea 
                            className="form-control form-control-solid" 
                            rows="4"
                            placeholder='Enter API end point'
                            name='api_end_point'
                            onChange={othersInputOnchange}
                            value={othersFormData.api_end_point}></textarea>
                    </div>
                )}

                {(responseType === 'static_response' || responseType === 'dynamic_response') && (
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            Add Fail Response
                        </label>
                        <textarea 
                            className="form-control form-control-solid" 
                            rows="4"
                            placeholder='Enter fail response' 
                            name='fail_response'
                            onChange={othersInputOnchange}
                            value={othersFormData.fail_response}
                        ></textarea>
                    </div>
                )}

           

                {/* {
                    responseType === 'static_response' &&
                    <>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Initial Response
                            </label>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter final response' 
                                name='initial_response'
                                onChange={othersInputOnchange}
                                value={othersFormData.initial_response}></textarea>
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label required">
                                Add Final Response
                            </label>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter final response' 
                                name='final_response'
                                onChange={othersInputOnchange}
                                value={othersFormData.final_response}></textarea>
                            {
                                othersFormError.final_response &&
                                <ValidationMessage className='text-danger' message ={othersFormError.final_response}/>
                            }
                        </div>
                        <div className='col-md-12 mb-5'>
                            <label className="form-label">
                                Add Fail Response
                            </label>
                            <textarea 
                                className="form-control form-control-solid" 
                                rows="4"
                                placeholder='Enter final response' 
                                name='fail_response'
                                onChange={othersInputOnchange}
                                value={othersFormData.fail_response}
                            ></textarea>
                        </div>
                    </>
                } */}


                <div className='col-md-12 mb-5'>
                    <label className="form-label required">
                        Sub Action Name
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('action_name')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <input
                        type="text"
                        className="form-control form-control-solid"
                        placeholder="Enter example"
                        name="action_name"
                        onChange={othersInputOnchange}
                        value={othersFormData.action_name}
                    />
                    {
                        othersFormError.action_name &&
                        <ValidationMessage className='text-danger' message ={othersFormError.action_name}/>
                    }
                </div>
                <div className='col-md-12 mb-5'>
                    <label className="form-label">
                        Follow Up Details 
                    </label>
                    <span 
                        className="fs-6 fw-semibold align-self-start cursor-pointer float-end"
                        onClick={(e) => infoOpenOnCLick('folow_up_details')}
                    >
                        <FontAwesomeIcon className='fs-5 text-gray-600' icon={faCircleInfo} />
                    </span>
                    <Select
                        className='react-select-styled react-select-solid react-select-sm' 
                        classNamePrefix='react-select' 
                        options={followUpDetailsOptions}
                        placeholder='Select an option'
                        name='folow_up_details'
                        onChange={othersInputOnchange}
                        value={othersFormData.folow_up_details}
                        isClearable
                    />
                </div>
                {/* {
                    followUpDetailsType === 'opt_in' &&
                    <div className='col-md-12 mb-5'>
                        <label className="form-label">
                            Affiram or Deny
                        </label>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select' 
                            options={[{label: 'Yes', value: 'yes'},{label: 'No', value:'no'} ]}
                            placeholder='Select an option' 
                            name='affiram_or_deny'
                            isClearable
                            value={othersFormData.affiram_or_deny}
                            onChange={othersInputOnchange}
                        />
                    </div>
                } */}
                {
                    followUpDetailsType === 'opt_in' &&
                    <div className='col-md-12'>
                        <label className="form-label">
                            Select Action
                        </label>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select' 
                            options={actionName}
                            placeholder='Select an option' 
                            name='select_action'
                            onChange={othersInputOnchange}
                            value={othersFormData.select_action}
                            isClearable
                        />
                    </div>
                }
                {
                    followUpDetailsType === 'closing_utterance' &&
                    <div className='col-md-12'> 
                        <label className="form-label">
                            Enter Closing Utterance 
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder="Enter Closing Utterance"
                            name="closing_utterance"
                            value={othersFormData.closing_utterance}
                            onChange={othersInputOnchange}
                        />
                    </div>
                }
                {
                    followUpDetailsType === 'feedback' &&
                    <div className='col-md-12'>
                        <label className="form-label">
                            Enter Feedback 
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder="Enter feedback"
                            name="feedback"
                            value={othersFormData.feedback}
                            onChange={othersInputOnchange}
                        />
                    </div>
                }
            </div>
            <div className='row'>
                <div className='col-md-12 m-auto text-end my-5'>
                    {
                        formActionType === 'insert' &&
                        <div 
                            className={`btn btn-dark btn-icon btn-sm ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={othersDataSaveHandler}
                        >
                            {
                                isButtonLoader ? 
                                <ButtonLoader/>
                                :
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            }
                        </div>
                    }
                    {
                        formActionType === 'update' &&
                        <div 
                            className={`btn btn-primary btn-sm ${isButtonLoader ? 'disabled' : ''}`} 
                            onClick={othersDataSaveHandler}
                        >
                            {
                                isButtonLoader ?
                                <ButtonLoader
                                    btnHtml='Please wait...'
                                    className='me-2'
                                />
                                :
                                'Update'
                            }
                        </div>
                    }
                </div>
            </div>
            {
                formValidateError?.product_features_association_data &&
                <AlertMessage
                    sub_title = {formValidateError?.product_features_association_data}
                    type = 'danger'
                />
            }
        </>
    )
})

export default ProductFeatureAssociationSetupForm